import AccountReferral from '@/components/AccountReferral'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		data: {},
		...opts,
		vueComponent: AccountReferral
	}

	let page = vuewidget(dom, options)
	return page
}